import React, { useState, useEffect } from 'react';
import { Table, Spin, message, Input, Space } from 'antd';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const OrgProviders = () => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [searchTerm, setSearchTerm] = useState('');
  const { orgId } = useParams();

  useEffect(() => {
    fetchProviders();
  }, [pagination.current, searchTerm]);

  const fetchProviders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/api/organizations/${orgId}/providers`,
        {
          params: {
            page: pagination.current,
            limit: pagination.pageSize,
            search: searchTerm,
          },
        }
      );

      const { data, meta } = response.data;

      setProviders(data);
      setPagination((prev) => ({
        ...prev,
        total: meta.total,
      }));
    } catch (error) {
      console.error('Error fetching providers:', error);
      message.error('Failed to load providers');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setPagination((prev) => ({ ...prev, current: 1 })); // Reset to first page on search
  };

  const handleTableChange = (pagination) => {
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '20px auto' }} />;
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (isActive ? 'Active' : 'Inactive'),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (date) => new Date(date).toLocaleString(),
    },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h2>Organization Providers</h2>
      <Space style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
        <Input.Search
          placeholder="Search providers"
          allowClear
          enterButton
          onSearch={handleSearch}
        />
      </Space>
      <Table
        dataSource={providers}
        columns={columns}
        rowKey="id"
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default OrgProviders;
